
import { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Modal from 'react-modal'
import { useForm } from 'react-hook-form'

import { projectContext, loadingContext, urlValue, unfolder, closeModalVw, openModalVw, useTranslate } from '../../lib'
// import AsideBar from './AsideBar'

import './chat-resume.scss'

export default function CallChatResume(props) {
    const { data } = props
    const [loading, setLoading] = useState(false)
    const [call, setCall] = useState(false)
    const [assement, setAssement] = useState(data) 
    const { t } = useTranslate();

    useEffect(() => {
        setAssement(data)
    }, [data])
  
    return (

        <>
            <div class="info-call w-full" style={{ backgroundColor: 'white', paddingTop: 10 }}  >
                <div class="info-call-item header flex items-center w-full justify-center" style={{ padding: 15, backgroundColor: "white" }} >
                    <div class="agents flex items-center ">
                        <div class="img">

                            <img alt='' src="/icons/tpAgent.png" style={{ width: 150, height: 100, objectFit: 'contain', marginRight: 30 }} />

                        </div>
                        <div class="img">
                            <img src="/icons/tpClient.png" alt="" style={{ width: 180, height: 100, objectFit: 'contain' }} />
                            {/* <!--<span>TP Client</span>--> */}
                        </div>
                    </div>
                    <div class="higiliths">
                        <img alt="" src="/icons/sentiment2.png" style={{ width: 142, height: 100, objectFit: 'contain' }} />
                    </div>
                </div>
                <div class="call-resume-container" >
                    <div class="call-resume-loading">
                        <h2>{t('common.conversation')}</h2>
                    </div>
                    <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                        <div id="sidebar-chat" class="call-resume-indicators" >
                            {assement?.sentiment.map((item, idex) => (
                                <div class=""  >
                                    {item.user !== '' &&
                                        <div class="call-resume-text" style={{paddingTop:15, paddingBottom:15}}>
                                            <div className='flex items-start justify-start'>
                                                <div className='flex flex-col items-start justify-start' style={{ marginLeft: 12 }}>
                                                    <img class="avatar_left" src="/icons/tpAgentMini.png" alt=""  />
                                                    <div class="text-left" style={{ color: '#575756', paddingLeft: '10px' }}>{item.time_message_agent}</div>
                                                </div>
                                                <div className='flex flex-col items-start justify-start'>
                                                    <div class="text-left">{t('reports.sentiment')}: {item.polarity}</div>
                                                    <div class="text-left" style={{ color: '#575756',width:500 }}>{item.user}</div>
                                                </div>

                                            </div>

                                        </div>
                                    }
                                    <div style={{ display: 'flex', justifyContent: 'flex-end'}} >
                                        <p class="text-bot chat-bot" style={{ color: '#575756',width:500 }}>{item?.bot}
                                            <img class="avatar_right" src="/icons/tpClientMini.png" alt="" />
                                        </p>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', color: '#575756', paddingRight: '20px' }}>{item.time_message_bot}</div>
                                </div>))}
                        </div>
                    </div>
                </div>
            </div>

        </>


    )
}
